import React, { useEffect, useState } from 'react'
import { BigPlayButton, ControlBar, LoadingSpinner, Player, PlayToggle } from 'video-react'

export function VideoPlayer({
  src,
  onPlayerChange = () => {},
  onChange = () => {},
  startTime = undefined,
  compact = false,
}) {
  const [player, setPlayer] = useState(undefined)
  const [playerState, setPlayerState] = useState(undefined)

  useEffect(() => {
    // Dynamically import the CSS file
    const loadCSS = async () => {
      await import('video-react/dist/video-react.css')
    }
    loadCSS()
  }, []) // Run once when the component is mounted

  useEffect(() => {
    if (playerState) {
      onChange(playerState)
    }
  }, [playerState])

  useEffect(() => {
    onPlayerChange(player)

    if (player) {
      player.subscribeToStateChange(setPlayerState)
    }
  }, [player])

  return (
    <div className="video-player mb-4">
      <div className=" overflow-hidden">
        <Player
          ref={(player) => {
            setPlayer(player)
          }}
          startTime={startTime}
          height={compact ? 400 : 450}
          fluid={false}
          responsive={true}
          className="rounded-lg overflow-hidden"
        >
          <source src={src} />
          <BigPlayButton position="center" />
          <LoadingSpinner />
          <ControlBar autoHide={false} disableDefaultControls={true}>
            <PlayToggle />
          </ControlBar>
        </Player>
      </div>
    </div>
  )
}
